import { Component, OnInit } from '@angular/core';
// import { AuthService } from './core/auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    /**
     * Constructor
     */
    constructor(
        // private _authService: AuthService,
    ) {
    }
    ngOnInit(): void {
        // setInterval(() => {
        //     return this._authService._checkToken().subscribe();
        // }, 3000);
    }
}
